import { JsonFilterPipe } from '../../filters/json-filter.pipe';
import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { CurrencyPipe } from '../../filters/currency.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemThumbnailComponent } from '../../components/item-thumbnail/item-thumbnail.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import ServiceRestServices from '../../services/service-rest.service';
import Session from '../../utils/session.service';
import Toast from '../../services/toast.service';
import FetchingService from '../../services/fetching.service';
import RoutingService from '../../services/routing.service';
import RestService from '../../services/core-rest.service';
import UserRestServices from '../../services/user-rest.service';
import ModalService from '../../services/modal.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MatSelectModule } from '@angular/material/select';
import { ModalMediaComponent } from '../../components/modal-media/modal-media.component';
import { ItemInfoPopoverComponent } from '../../components/item-info-popover/item-info-popover.component';

@Component({
	standalone: true,
	selector: 'sp-settings',
	templateUrl: './sp-settings.component.html',
	imports: [
		CommonModule, MatSelectModule, JsonFilterPipe, LowerCasePipe,
		CurrencyPipe, TranslatePipe, ItemThumbnailComponent, LoaderOverlayComponent, FormsModule, ItemInfoPopoverComponent
	]
})
export default class SpSettingsView implements OnInit {
	private config: Config = inject(Config);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private session: Session = inject(Session);
	private toast: Toast = inject(Toast);
	private fetchingService: FetchingService = inject(FetchingService);
	private routingService: RoutingService = inject(RoutingService);
	private restService: RestService = inject(RestService);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private modalService: ModalService = inject(ModalService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('spSettings').then(() => {
			this.onResolve();
		});
	};
	
	onResolve() {
		this.initialize();
		
		this.vm.hasSubcategorySelected = this.hasSubcategorySelected;
		this.vm.addLanguage = this.addLanguage;
		this.vm.removeLanguage = this.removeLanguage;
		this.vm.submit = this.submit;
		this.vm.isDescriptionRequired = this.isDescriptionRequired;
		this.vm.handleTabClick = this.handleTabClick;
		this.vm.canEditMentalHealthTags = this.canEditMentalHealthTags;
		this.vm.getTagsText = this.getTagsText;
		this.vm.getTherapiesText = this.getTherapiesText;
		this.vm.getCoachingTopicsText = this.getCoachingTopicsText;
		this.vm.hasTagTranslations = this.hasTagTranslations;
		this.vm.hasTherapyTranslations = this.hasTherapyTranslations;
		this.vm.removeSelectedItem = this.removeSelectedItem;
		this.vm.removeSelectedTherapyItem = this.removeSelectedTherapyItem;
		this.vm.removeSelectedCoachingTopicItem = this.removeSelectedCoachingTopicItem;
		this.vm.reLoadDescriptions = this.reLoadDescriptions;
		this.vm.hasDescriptionTranslation = this.hasDescriptionTranslation;
		this.vm.handleLocationSearch = this.handleLocationSearch;
		this.vm.handleLocationSelect = this.handleLocationSelect;
		this.vm.clearLocationSearch = this.clearLocationSearch;
		this.vm.openFileSelect = this.openFileSelect;
		this.vm.watchVideo = this.watchVideo;
		this.vm.handleMediaUpload = this.handleMediaUpload;
		this.vm.openFile = this.openFile;
		this.vm.deleteFile = this.deleteFile;
		this.vm.canChangePriceAndTime = this.canChangePriceAndTime;
		this.vm.getFieldsForSubcategory = this.getFieldsForSubcategory;
		this.vm.isLocationRequired = this.isLocationRequired;
		this.vm.hasSelectedCategory = this.hasSelectedCategory;
		this.vm.isPartnerAccount = this.isPartnerAccount;
		this.vm.filterPartnerAccountFields = this.filterPartnerAccountFields;
	}
	
	handleTabClick(index) {
		this.vm.selectedTranslation = index;
	}
	
	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		this.handleMediaUpload(input);
	}
	
	handleMediaUpload(input) {
		this.vm.loading = true;
		var medias: any = input.files;
		if (!medias || !medias.length || this.vm.processing) return;
		var media: any = medias[0];
		media.groupId = Date.now();
		var data: any = new FormData();
		data.append('file', media);
		this.vm.processing = true;
		this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Profile.MEDIA_UPLOAD_INIT,
			{ media: media, user: this.vm.user });
		
		var params: any = {
			id: this.vm.user.id,
			fileName: media.name,
		};
		
		this.userRestServices.uploadProfileVideo(params, data, 
			(res) => {
				res.groupId = media.groupId;
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Profile.MEDIA_UPLOAD_START,
					this.createMediaData(res));
				this.handleInputReset(input);
				this.vm.videoUploaded = 'LOADING';
				this.vm.loading = false;
			},
			(err) => {
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Profile.MEDIA_UPLOAD_ERROR,
					this.createMediaData(media, err));
				this.handleInputReset(input);
				this.vm.loading = false;
			}
		);
	}
	
	handleInputReset(input) {
		this.vm.processing = false;
		input.value = '';
	}
	
	createMediaData(media, error?) {
		var data: any = media;
		data.user = this.vm.user;
		data.modified = new Date();
		data.created = new Date();
		data.postType = 'VIDEO';
		data.contentType = 'VIDEO';
		if (error) data.error = error;
		
		return data;
	}
	
	canEditMentalHealthTags() {
		if (!this.vm.options || !this.vm.options.fields) return false;
		
		var category: any = this.vm.options.fields.find((field) => { return field.id === this.vm.category; }) || {};
		return category.subcategory === 'PSYCHOLOGY' || category.subcategory === 'COACHING';
	}
	
	getTagsText() {
		return this.angularFilterHelperService.translate('Subscription.Placeholder.Tags');
	}
	
	getTherapiesText() {
		return this.angularFilterHelperService.translate('Subscription.Placeholder.Therapies');
	}

	hasTagTranslations() {
		return Array.isArray(this.vm.tagTranslations) && this.vm.tagTranslations.length > 0;
	}

	hasTherapyTranslations() {
		return Array.isArray(this.vm.therapyTranslations) && this.vm.therapyTranslations.length > 0;
	}

	getCoachingTopicsText() {
		return this.angularFilterHelperService.translate('Subscription.Placeholder.CoachingTopics');
	}
	
	removeSelectedItem($event, item) {
		this.vm.selectedTags = this.vm.selectedTags.filter((tagTranslation) => {
			return tagTranslation.tag.id !== item.tag.id
		});
	}
	
	removeSelectedTherapyItem($event, item) {
		this.vm.selectedTherapies = this.vm.selectedTherapies.filter((therapyTranslation) => {
			return therapyTranslation.therapy.id !== item.therapy.id
		});
	}
	
	removeSelectedCoachingTopicItem($event, item) {
		this.vm.selectedCoachingTopics = this.vm.selectedCoachingTopics.filter((coachingTopic) => {
			return coachingTopic.id !== item.id
		});
	}
	
	openFileSelect(id) {
		var el: any = document.getElementById(id);
		if (el) {
			el.click();
		}
	}
	
	openFile() {
		
	}
	
	watchVideo() {
		this.vm.service.profileVideoPost.postType = 'VIDEO';
		this.modalService.openMedia(
			ModalMediaComponent,
			{
				media: this.vm.service.profileVideoPost,
				chat: {},
				modalId: 'modal-' + this.vm.service.profileVideoPost.id
			}
		);
	}
	
	deleteFile() {
		this.vm.loading = true;
		this.userRestServices.deleteProfileVideoUploaded({userId: this.vm.user.id}, () => {
			this.vm.loading = false;
			this.vm.videoUploaded = 'NOT_LOADED';
		}, (err) => {
			this.vm.loading = false;
			console.log(err);
		});
	}

	isLocationRequired() {
		return (this.vm.service?.typeOfAppointment === 'FACE_TO_FACE_SESSION_ONLY' || this.vm.service?.typeOfAppointment === 'VIDEO_AND_FACE_TO_FACE_SESSIONS');
	}

	isPartnerAccount() {
		return this.vm.user && this.vm.user.partnerAccount === true;
	}

	filterPartnerAccountFields(fields) {
		if (!this.isPartnerAccount() || !Array.isArray(fields)) {
			return fields;
		}
		return fields.filter((field) => {
			return field.subcategory === 'COACHING' || field.subcategory === 'PSYCHOLOGY';
		});
	}

	submit(mainForm: any) {
		this.vm.submitted = true;
		if (!this.vm.initialized || this.vm.loading || mainForm.invalid
			|| !this.hasSelectedCategory()
			|| !this.vm.service?.pricing.timePerPrice
			|| this.vm.service?.pricing.price === null
			|| this.vm.service?.pricing.price === undefined
			|| (!this.isPartnerAccount() && !this.vm.service?.nextAvailableLeadTimeInMinutes)
			|| !this.vm.service.languages
			|| this.vm.service.languages?.length == 0
			|| (this.vm.service.languages.length == 1 && this.vm.service.languages[0].language == null)
			|| (this.vm.isLocationRequired() && !this.vm.location)) {
			this.vm.hasErrors = true;
			return;
		}
		
		this.vm.translationsValid = true;
		var chk: number = 0;
		if (!this.isPartnerAccount()) {
			this.angularHelperService.forEach(this.vm.tabs, (languageTab) => {
				if (!this.hasDescriptionTranslation(languageTab.label)) {
					this.vm.translationsValid = false;
					this.vm.selectedTranslation = chk;
				}
				chk++;
			});
		}
		if (!this.vm.translationsValid) {
			this.vm.hasErrors = true;
			return;
		}
		
		this.vm.hasErrors = false;
		this.vm.loading = true;
		
		var category: any = this.vm.options.fields.find((field) => { return field.id === this.vm.category; }) || {};
		var tags: Array<any> = [];
		var therapies: Array<any> = [];
		var coachingTopics: Array<any> = [];
		if (this.vm.selectedTags) {
			this.angularHelperService.forEach(this.vm.selectedTags, (tagTranslation) => {
				tags.push({tag: {id: tagTranslation.tag.id}});
			});
		}
		if (this.vm.selectedTherapies && this.vm.hasSubcategorySelected('PSYCHOLOGY')) {
			this.angularHelperService.forEach(this.vm.selectedTherapies, (therapyTranslation) => {
				therapies.push({therapy: {id: therapyTranslation.therapy.id}});
			});
		}
		if (this.vm.selectedCoachingTopics) {
			this.angularHelperService.forEach(this.vm.selectedCoachingTopics, (selectedCoachingTopic) => {
				coachingTopics.push({digitalResource: {id: selectedCoachingTopic.id}});
			});
		}
		if (!!this.vm.linkedinUrl) {
			this.vm.linkedinUrl = this.vm.linkedinUrl.replace('http://', 'https://');
			if (!this.vm.linkedinUrl.startsWith('https://')) {
				this.vm.linkedinUrl = 'https://' + this.vm.linkedinUrl;
			}
		}
		if (!!this.vm.websiteUrl) {
			this.vm.websiteUrl = this.vm.websiteUrl.replace('http://', 'https://');
			if (!this.vm.websiteUrl.startsWith('https://')) {
				this.vm.websiteUrl = 'https://' + this.vm.websiteUrl;
			}
		}
		var data: any = {
			category: category.category,
			subcategory: category.subcategory,
			furtherSubcategory: category.furtherSubcategory,
			description: this.angularHelperService.copy(this.vm.service.description),
			descriptions: this.angularHelperService.copy(this.vm.service.descriptions),
			languages: this.angularHelperService.copy(this.vm.service.languages),
			tags: tags,
			therapies: therapies,
			coachingTopics: coachingTopics,
			linkedinUrl: this.angularHelperService.copy(this.vm.linkedinUrl),
			websiteUrl: this.angularHelperService.copy(this.vm.websiteUrl),
			location: this.angularHelperService.copy(this.vm.location),
			licenseNumber: this.angularHelperService.copy(this.vm.service.licenseNumber),
			pricing: this.angularHelperService.copy(this.vm.service.pricing),
			nextAvailableLeadTimeInMinutes: this.angularHelperService.copy(this.vm.service.nextAvailableLeadTimeInMinutes),
			user: this.angularHelperService.copy(this.vm.service.user || { id: this.vm.user.id }),
			typeOfAppointment: this.angularHelperService.copy(this.vm.service.typeOfAppointment)
		};
		data.pricing.currency = this.vm.currency;
		
		this.serviceRestServices.postSignUpOne(data, (res) => {
			var sessionData: any = this.session.getSession();
			sessionData.user.service = res;
			this.session.updateSession(sessionData);
			this.fetchingService.clear('SESSION');
			this.angularHelperService.createTimer(() => {
				this.routingService.reset().then(() => {
					this.toast.showWithTranslation('Toast.Profile.Updated_Service');
					this.angularRoutingHelperService.goHomeAndKeepHistory(this.session.getSession() ? this.session.getSession().user : null);
				});
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		});
	}
	
	isDescriptionRequired() {
		if (this.isPartnerAccount()) return false;
		var isRequired: any = false;
		this.vm.service.descriptions.map(function(item) {
			if (!item.description || item.description.length == 0) isRequired = true;
		});
		
		return isRequired;
	}
	
	initialize() {
		this.vm.user = this.session.getSession().user;
		this.vm.sessionUserLanguage = this.session.getSession().user && this.session.getSession().user.deviceLanguage;
		this.vm.loading = true;
		this.vm.maxLanguagesAllowed = 6;
		this.vm.uid = 'sp-' + Date.now();
		this.vm.videoId = 'vid-' + Date.now();
		this.vm.videoUploaded = 'NOT_LOADED';
		this.vm.tagTranslations = [];
		this.vm.therapyTranslations = [];
		this.vm.faceToFaceDescription = this.angularFilterHelperService.translate('Subscription.Label.FaceToFaceAvailable');
		
		this.getTranslations();

		this.vm.typeOfAppointments = ['VIDEO_SESSION_ONLY', 'FACE_TO_FACE_SESSION_ONLY', 'VIDEO_AND_FACE_TO_FACE_SESSIONS'];
		
		var promises: Array<any> = [];
		promises.push(this.getOptions());
		promises.push(this.getService());
		promises.push(this.getTags());
		promises.push(this.getTherapies());
		promises.push(this.getCoachingTopics());
		
		this.angularHelperService.getPromise().all(promises).then((res) => {
			this.vm.options = this.vm.options || {};
			this.vm.options.fields = Array.isArray(this.vm.options.fields) ? this.vm.options.fields : [];
			this.vm.options.fields = this.vm.options.fields.map((field, index) => { field.id = index; return field; });
			var category: any = this.vm.options.fields.find((field) => {
				return this.vm.service.category === field.category &&
				this.vm.service.subcategory === field.subcategory &&
				this.vm.service.furtherSubcategory == field.furtherSubcategory;
			});
			if (category && category.id !== null && category.id !== undefined) this.vm.category = category.id;
			if (this.vm.service.websiteUrl) this.vm.websiteUrl = this.vm.service.websiteUrl;
			if (this.vm.service.linkedinUrl) this.vm.linkedinUrl = this.vm.service.linkedinUrl;
			if (this.vm.service.location) this.vm.location = this.vm.service.location;
			if (!!this.vm.service.profileVideoPost && this.vm.service.profileVideoPost.uuid) {
				this.vm.videoUploaded = 'LOADING';
				if (this.vm.service.profileVideoPost.fileUrl) {
					this.vm.videoUploaded = 'LOADED';
				}
			}
			if (this.vm.service.tags && this.hasTagTranslations()) {
				this.vm.selectedTags = [];
				TAGS: for (var st = 0; st < this.vm.service.tags.length; st++) {
					for (var t = 0; t < this.vm.tagTranslations.length; t++) {
						if (this.vm.service.tags[st].tag.id === this.vm.tagTranslations[t].tag.id) {
							this.vm.selectedTags.push(this.vm.tagTranslations[t]);
							continue TAGS;
						}
					}
				}
			}
			if (this.vm.service.therapies && this.hasTherapyTranslations()) {
				this.vm.selectedTherapies = [];
				THERAPIES: for (var st = 0; st < this.vm.service.therapies.length; st++) {
					for (var t = 0; t < this.vm.therapyTranslations.length; t++) {
						if (this.vm.service.therapies[st].therapy.id === this.vm.therapyTranslations[t].therapy.id) {
							this.vm.selectedTherapies.push(this.vm.therapyTranslations[t]);
							continue THERAPIES;
						}
					}
				}
			}
			if (this.vm.service.coachingTopics) {
				this.vm.selectedCoachingTopics = [];
				COACHING_TOPICS: for (var st = 0; st < this.vm.service.coachingTopics.length; st++) {
					for (var t = 0; t < this.vm.coachingTopics.length; t++) {
						if (this.vm.service.coachingTopics[st].digitalResource.id === this.vm.coachingTopics[t].id) {
							this.vm.selectedCoachingTopics.push(this.vm.coachingTopics[t]);
							continue COACHING_TOPICS;
						}
					}
				}
			}
			if (this.vm.loading) {
				this.angularHelperService.createTimer(() => {
					this.vm.loading = false;
					this.vm.initialized = true;
				}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			}
		});
	}
	
	getTranslations() {
		this.vm.translations = ['en'];
		
		if (this.vm.service && this.vm.service.languages && this.vm.options && this.vm.options.languageCodes) {
			this.angularHelperService.forEach(this.vm.service.languages, (lang) => {
				var langCode: any = this.vm.options.languageCodes[lang.language];
				if (!this.vm.translations.includes(langCode)) {
					this.vm.translations.push(langCode);
				}
			});
		}
		
		this.vm.selectedTranslation = this.vm.selectedTranslation || 0;
		this.loadDescriptions(this.vm.service);
		this.getTabs();
	}
	
	getFieldsForSubcategory(subcategory) {
		if (!this.vm.options || !this.vm.options.fields || !subcategory) return [];
		return this.vm.options.fields.filter(function(item) {
			return item.subcategory === subcategory && !!item.furtherSubcategory;
		});
	}
	
	hasFieldsForSubcategory(subcategory: any): boolean {
		if (!this.vm.options.fields || !subcategory) return false;
		return this.vm.options.fields.some(item => item.subcategory === subcategory && !!item.furtherSubcategory);
	}
	
	canChangePriceAndTime() {
		// If subcategory not COACHING or PSYCHOLOGY, then allow editing
		// otherwise allow editing only first time (status is INCOMPLETE)
		return !(this.vm.service.subcategory === 'COACHING' || this.vm.service.subcategory === 'PSYCHOLOGY')
		|| !this.vm.service.status || this.vm.service.status === 'INCOMPLETE';
	}
	
	getTabs() {
		var tabs: Array<any> = [];
		this.vm.translations.map(function(item) {
			if (item) {
				tabs.push({
					label: item.toString().toUpperCase()
				});
			}
		});
		this.vm.tabs = tabs;
	}
	
	handleLocationSearch(locationPart) {
		// var countries = countryCity.getAllCountries();
		// var cities = countryCity.getAllCities();
		// console.log(countries);
		// var location = countries.map((item, index) => {
			// 				item.id = index + 1;
			// 				return item;
		// });
		// var deferred = this.angularHelperService.getDeferredPromise();
		//
		// this.restService.getBusinessClientSearch({ name: locationPart })
		// 	.then((items) => {
			// 		this.vm.isLocationPanelOverflowVisible = true;
			// 		var employers = items.map((item, index) => {
				// 			item.id = index + 1;
				// 			return item;
			// 		});
			// 		deferred.resolve(employers);
		// 	})
		// 	.catch((err) => {
			// 		console.error(err);
			// 		deferred.reject(err);
		// 	});
		//
		// return deferred.promise;
	}
	
	handleLocationSelect(selectedLocation) {
		this.vm.location = this.angularHelperService.copy(selectedLocation);
	}
	
	clearLocationSearch() {
		this.vm.location = undefined;
	}
	
	getOptions() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.serviceRestServices.getBusinessSignupOptions({ language: this.vm.user.deviceLanguage, type: 'health' }, (data) => {
			this.vm.options = data || {};
			this.vm.options.fields = Array.isArray(this.vm.options.fields) ? this.vm.options.fields : [];
			this.vm.options.fields = this.filterPartnerAccountFields(this.vm.options.fields);
			this.vm.options.currencies = Array.isArray(this.vm.options.currencies) ? this.vm.options.currencies : [];
			this.vm.currency = this.vm.options.currencies[0];
			this.vm.subcategories = [];
			this.angularHelperService.forEach(this.vm.options.fields, (field) => {
				if (!field.furtherSubcategory) this.vm.subcategories.push(field);
			});
			this.getTranslations();
			deferred.resolve();
		}, () => {
			deferred.reject();
		});
		
		return deferred.promise;
	}
	
	getTags() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.restService.getServiceProviderTags({ language: this.vm.sessionUserLanguage })
			.then((tagTranslations) => {
				this.vm.tagTranslations = Array.isArray(tagTranslations) ? tagTranslations : [];
				deferred.resolve();
			})
			.catch((err) => {
				console.error(err);
				this.vm.tagTranslations = [];
				deferred.resolve();
			});
		
		return deferred.promise;
	}
	
	getTherapies() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.fetchingService.get('THERAPY_TOPIC_TRANSLATIONS', { params: { language: this.vm.sessionUserLanguage || 'en_GB' } })
			.then((response) => {
				this.vm.therapyTranslations = Array.isArray(response) ? response : [];
				deferred.resolve();
			})
			.catch((err) => {
				console.error(err);
				this.vm.therapyTranslations = [];
				deferred.resolve();
			});
		return deferred.promise;
	}
	
	getCoachingTopics() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.fetchingService.get('COACHING_TOPICS', { params: { language: this.vm.sessionUserLanguage || 'en_GB' } })
			.then((response) => {
				this.vm.coachingTopics = response;
				deferred.resolve();
			});
		return deferred.promise;
	}
	
	getService() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.getTranslations();
		
		this.serviceRestServices.getServiceByUserId({ userId: this.vm.user.id }, (service) => {
			if (!service) {
				service = {};
				service['pricing'] = {};
			}
			if (!service.pricing.price) {
				service.pricing.price = 0;
			}
			service.descriptions = service.descriptions || [];
			this.loadDescriptions(service);
			if (!service.languages || !service.languages.length) service.languages = [{ language: null }];
			this.vm.service = service;
			this.getTranslations();
			deferred.resolve();
		}, () => {
			deferred.reject();
		});
		
		return deferred.promise;
	}
	
	loadDescriptions(service) {
		if (service) {
			this.vm.translations.map((translation) => {
				var description: any = service.descriptions.filter(function(item) { return item.language == translation; })[0];
				if (!description) {
					service.descriptions.push({ language: translation, description: '' });
					description = service.descriptions[service.descriptions.length - 1];
				}
				description.translations = {
					serviceDescription: this.angularFilterHelperService.translate('Booking.Service_Description'),
					serviceDescriptionInfo: this.angularFilterHelperService.translate('Subscription.Other.Description'),
					serviceDescriptionLength: this.angularFilterHelperService.translate('Subscription.Other.Description_Length'),
					serviceDescriptionError: this.angularFilterHelperService.translate('Subscription.Error.100_to_300')
				};
			});
		}
	}
	
	hasSubcategorySelected(code) {
		return this.hasSelectedCategory() && !!this.vm.options && !!this.vm.options.fields
			? this.vm.options.fields[this.vm.category].subcategory === code
			: false;
	}

	hasSelectedCategory() {
		return this.vm.category !== null && this.vm.category !== undefined;
	}
	
	addLanguage() {
		this.vm.service.languages = this.vm.service.languages || [];
		if (this.vm.service.languages.length >= this.vm.options.languages.length) return;
		this.vm.service.languages.push({ language: null });
		this.getTranslations();
	}
	
	removeLanguage(i) {
		this.vm.service.languages.splice(i, 1);
		this.vm.selectedTranslation = 0;
		this.getTranslations();
	}
	
	reLoadDescriptions() {
		this.getTranslations();
	}
	
	getLeadTimeInHours(minutes: number): string {
		if (!minutes || minutes < 60) {
			return (minutes / 60).toFixed(1);
		}

		const hours = minutes / 60;
		return hours % 1 === 0 ? String(hours) : hours.toFixed(1);
	}

	hasDescriptionTranslation(lang) {
		if (this.isPartnerAccount()) {
			return true;
		}
		if (!this.vm.service || lang.label) {
			return true;
		}
		var description: any = this.vm.service.descriptions.filter(function(item) {
			return item.language == lang.toString().toLowerCase();
		})[0];
		return !!description && !!description.description && description.description.length >= 100;
	}
	
}
